module.exports = __webpack_public_path__ + "static/img/PcIndex.fb0dbf71.png";